import React, {Fragment} from 'react';
export const InputField = ({ input, placeholder, disabled, className, label, type, meta: { touched, error, warning } }) => (
    <Fragment>
        <input disabled={disabled || false} placeholder={placeholder} className={className + (touched && error ? ' is-danger' : '')} {...input} type={type}/>
        {touched && ((error && <p className="help is-danger">{error}</p>) || (warning && <span>{warning}</span>))}
    </Fragment>
)